var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 62.09 17.91 80 40 80C62.09 80 80 62.09 80 40C80 17.91 62.09 0 40 0C17.91 0 0 17.91 0 40Z",
    fill: "#E0E9FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.89 44.0505C63.13 44.0505 62.51 43.4305 62.51 42.6705V34.4805C62.51 22.0505 52.44 11.9705 40 11.9705C27.57 11.9705 17.49 22.0405 17.49 34.4805V42.6705C17.51 43.4305 16.91 44.0705 16.15 44.0905C15.39 44.1105 14.75 43.5105 14.73 42.7505C14.73 42.7305 14.73 42.7005 14.73 42.6805V34.4905C14.73 20.5405 26.05 9.23047 40 9.23047C53.95 9.23047 65.25 20.5405 65.26 34.4905V42.6805C65.26 43.4405 64.64 44.0605 63.88 44.0605L63.89 44.0505Z",
    fill: "white",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6401 47.7202C14.6401 48.9402 15.6301 49.9302 16.8401 49.9302H21.2501V34.4902H16.8401C15.6201 34.4902 14.6401 35.4702 14.6401 36.6902V47.7202Z",
    fill: "#2B6BF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.23 45.5104C10.23 46.7304 11.22 47.7104 12.43 47.7104H14.63V36.6904H12.43C11.22 36.6904 10.23 37.6804 10.23 38.8904V45.5104Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6401 47.7202C14.6401 48.9402 15.6301 49.9302 16.8401 49.9302H21.2501V34.4902H16.8401C15.6201 34.4902 14.6401 35.4702 14.6401 36.6902V47.7202Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.23 45.5104C10.23 46.7304 11.22 47.7104 12.43 47.7104H14.63V36.6904H12.43C11.22 36.6904 10.23 37.6804 10.23 38.8904V45.5104Z",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.74 44.4099C58.82 54.7599 50.49 63.2099 40.13 63.2899C29.78 63.3699 21.33 55.0399 21.25 44.6799C21.25 44.5899 21.25 44.4999 21.25 44.4099V35.5899C21.33 25.2399 29.78 16.9099 40.13 16.9799C50.37 17.0499 58.66 25.3399 58.74 35.5899V44.4099Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.74 44.4099C58.82 54.7599 50.49 63.2099 40.13 63.2899C29.78 63.3699 21.33 55.0399 21.25 44.6799C21.25 44.5899 21.25 44.4999 21.25 44.4099V35.5899C21.33 25.2399 29.78 16.9099 40.13 16.9799C50.37 17.0499 58.66 25.3399 58.74 35.5899V44.4099Z",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5401 32.1598C59.6301 32.6898 59.3201 33.2198 58.8101 33.3898C48.9001 36.7298 38.0501 32.2398 33.3801 22.8798C33.1101 22.3298 32.4501 22.1098 31.9101 22.3798C31.6401 22.5098 31.4301 22.7598 31.3401 23.0498C29.6101 28.6198 25.6401 33.2098 20.3801 35.7398C20.3301 35.7598 20.2701 35.7598 20.2201 35.7398C20.1701 35.7098 20.1501 35.6598 20.1401 35.5998C20.1401 27.8998 24.6001 20.8898 31.5701 17.6298C31.7901 17.5198 32.0201 17.4198 32.2501 17.3198C42.3501 13.0498 53.9901 17.7798 58.2501 27.8798C58.8301 29.2598 59.2601 30.6998 59.5201 32.1798L59.5401 32.1598Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9702 40.9101C30.6902 39.1901 33.4802 39.1901 35.2102 40.9101",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4102 41.0996C46.1302 39.3796 48.9202 39.3796 50.6502 41.0996",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4902 51.3896C37.5302 55.7996 42.4702 55.7996 45.5202 51.3896H34.4902Z",
    fill: "#2B6BF3",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8701 69.8697C27.8701 70.7797 33.3001 71.5197 40.0001 71.5197C46.7001 71.5197 52.1301 70.7797 52.1301 69.8697C52.1301 68.9597 46.7001 68.2197 40.0001 68.2197C33.3001 68.2197 27.8701 68.9597 27.8701 69.8697Z",
    fill: "#2B6BF3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5401 32.1598C59.6301 32.6898 59.3201 33.2198 58.8101 33.3898C48.9001 36.7298 38.0501 32.2398 33.3801 22.8798C33.1101 22.3298 32.4501 22.1098 31.9101 22.3798C31.6401 22.5098 31.4301 22.7598 31.3401 23.0498C29.6101 28.6198 25.6401 33.2098 20.3801 35.7398C20.3301 35.7598 20.2701 35.7598 20.2201 35.7398C20.1701 35.7098 20.1501 35.6598 20.1401 35.5998C20.1401 27.8998 24.6001 20.8898 31.5701 17.6298C31.7901 17.5198 32.0201 17.4198 32.2501 17.3198C42.3501 13.0498 53.9901 17.7798 58.2501 27.8798C58.8301 29.2598 59.2601 30.6998 59.5201 32.1798L59.5401 32.1598Z",
    stroke: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.36 47.7202C65.36 48.9302 64.37 49.9202 63.16 49.9202H58.75V34.4902H63.16C64.38 34.4902 65.36 35.4702 65.36 36.6902V47.7202Z",
    fill: "#2B6BF3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M65.36 47.7202C65.36 48.9302 64.37 49.9202 63.16 49.9202H58.75V34.4902H63.16C64.38 34.4902 65.36 35.4702 65.36 36.6902V47.7202Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7701 45.5104C69.7701 46.7304 68.7901 47.7104 67.5701 47.7204H65.3701V36.6904H67.5701C68.7901 36.6904 69.7701 37.6704 69.7701 38.8904V45.5004V45.5104Z",
    fill: "white",
    stroke: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.02 49.8496V52.2696C16.02 56.2796 20.05 59.5296 25.01 59.5296H26",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8402 58.8403C31.8402 60.6703 30.3602 62.1503 28.5302 62.1503C26.7002 62.1503 25.2202 60.6703 25.2202 58.8403C25.2202 57.0103 26.7002 55.5303 28.5302 55.5303C30.3602 55.5303 31.8402 57.0103 31.8402 58.8403Z",
    fill: "#2B6BF3",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.2db93d7b865c3dc329eda8747be370b9.svg";
export { ForwardRef as ReactComponent };